const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="w-16 h-16 rounded-full border-4 border-pink-200 animate-pulse"></div>
          <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-blue-200 animate-pulse animation-delay-150"></div>
          <div className="absolute inset-2 w-12 h-12 rounded-full border-4 border-t-pink-500 border-r-transparent border-b-blue-500 border-l-transparent animate-spin"></div>
        </div>
        <p className="text-gray-600 font-medium animate-pulse">로딩 중...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner
